import { CellData, ColumnConfig, ComponentData, TabConfig, TabData, TabDisplayConfig, TableData } from '@ddt-web/data-service';
import * as get from 'lodash/get';
import * as groupBy from 'lodash/groupBy';
import * as set from 'lodash/set';
import * as size from 'lodash/size';

// TODO mraicu: remove this file and make sure no component uses mocks when we have ESG data
export const mockRankingsOptions = {
	config: { id: 'esg.rankings' } as TabConfig,
	tableData: [
		{
			cells: [
				[new CellData(new ColumnConfig(null, null, null, 'cell'), 'Portfolio D', 'Portfolio D')],
				[new CellData(new ColumnConfig(null, null, null, 'cell'), 'Portfolio E', 'Portfolio E')],
				[new CellData(new ColumnConfig(null, null, null, 'cell'), 'Portfolio F', 'Portfolio F')]
			],
			headersY: [
				new CellData(new ColumnConfig(null, null, null, 'cell'), 'Portfolio A', 'Portfolio A'),
				new CellData(new ColumnConfig(null, null, null, 'cell'), 'Portfolio B', 'Portfolio B'),
				new CellData(new ColumnConfig(null, null, null, 'cell'), 'Portfolio C', 'Portfolio C')
			],
			headersX: [new CellData(new ColumnConfig(null, null, null, 'cell'), 'Bottom', 'Bottom')],
			firstColumnTitle: new CellData(new ColumnConfig(null, null, null, 'cell'), 'Top', 'Top')
		} as TableData
	],
	displayConfig: { visible: true } as TabDisplayConfig,
	error: undefined
} as TabData;

export const mockPercentagesOptions: TabData = {
	config: { id: 'esg.percentages' } as TabConfig,
	tableData: [
		{
			cells: [
				[new CellData(new ColumnConfig(null, null, null, 'cell'), '73', '73%')],
				[new CellData(new ColumnConfig(null, null, null, 'cell'), '78', '78%')],
				[new CellData(new ColumnConfig(null, null, null, 'cell'), '86', '86%')]
			],
			headersY: [
				new CellData(new ColumnConfig(null, null, null, 'cell'), 'Portfolio A', 'Portfolio A'),
				new CellData(new ColumnConfig(null, null, null, 'cell'), 'Portfolio B', 'Portfolio B'),
				new CellData(new ColumnConfig(null, null, null, 'cell'), 'Portfolio C', 'Portfolio C')
			],
			headersX: [new CellData(new ColumnConfig(null, null, null, 'cell'), 'Percentage', 'Percentage')],
			firstColumnTitle: new CellData(new ColumnConfig(null, null, null, 'cell'), 'Top', 'Top')
		} as TableData
	],
	displayConfig: { visible: true } as TabDisplayConfig,
	error: undefined
} as TabData;

const mockRankingsTab = new TabData(mockRankingsOptions.config, mockRankingsOptions.tableData, mockRankingsOptions.displayConfig);
const mockPercentagesTab = new TabData(mockPercentagesOptions.config, mockPercentagesOptions.tableData, mockPercentagesOptions.displayConfig);
const mockChart = (tabs: TabData[]) => {
	return size(tabs) > 1
		? [[3, 8, 4, 2, 10, 7, 6], [7, 3, 1, 9, 4, 5, 2], [9, 10, 6, 7, 1, 4, 9], [2, 8, 6, 2, 10, 4, 7]]
		: [[88, 30, 160, 180, 110, 70, 150]];
};

export function mockComponentData(componentData: ComponentData): ComponentData {
	const { asOfDateTab, chartTabs } = groupBy(componentData.tabs,
		(tab) => {
			const id = get(tab, 'config.id');
			if (id === 'esg.asOfDate') { return 'asOfDateTab'; }
			if (id === 'esg.rankings') { return 'rankingsTab'; }
			if (id === 'esg.percentages') { return 'percentages'; }
			return 'chartTabs';
		});
	const mockChartValues = mockChart(chartTabs);
	const mockTabs = chartTabs.map((tab, tabIndex) => {
		get(tab, 'tableData[0].cells[0]', []).map((cell, index) => {
			set(cell, 'rawValue', mockChartValues[tabIndex][index]);
			set(cell, 'formattedValue', mockChartValues[tabIndex][index]);
		});
		return tab;
	});

	return new ComponentData(componentData.id, [...asOfDateTab, ...mockTabs, mockRankingsTab, mockPercentagesTab],
		componentData.portfolioData, false, undefined, true, true);
}





